module.exports = __webpack_public_path__ + "assets/img/favicon/apple-icon-60x60.642ffc78c466222fffe6326d3336b933.png";